import { render, staticRenderFns } from "./IkasKategori.vue?vue&type=template&id=05cf04ea&scoped=true"
import script from "./IkasKategori.vue?vue&type=script&lang=js"
export * from "./IkasKategori.vue?vue&type=script&lang=js"
import style0 from "./IkasKategori.vue?vue&type=style&index=0&id=05cf04ea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05cf04ea",
  null
  
)

export default component.exports